import React from 'react';
import { ChefHat, Recycle, Heart } from 'lucide-react';

const About: React.FC = () => {
  return (
    <section className="about-section">
      <div className="container">
        <h2 className="section-title">Nuestra Historia</h2>
        <div className="about-content">
          <div className="story-flow">
            <div className="story-step">
              <div className="step-icon">
                <ChefHat size={40} />
              </div>
              <div className="step-content">
                <h3>Todo Comenzó con Ceviches</h3>
                <p>
                  Nuestro negocio principal es un restaurante de ceviches donde servimos
                  deliciosas comidas peruanas. Cada día, generábamos muchas anillas de lata
                  que simplemente se desperdiciaban.
                </p>
              </div>
            </div>

            <div className="story-step">
              <div className="step-icon">
                <Recycle size={40} />
              </div>
              <div className="step-content">
                <h3>La Inspiración del Reciclaje</h3>
                <p>
                  Un día nos preguntamos: ¿qué pasaría si transformáramos estos residuos
                  en algo hermoso? Así nació la idea de crear carteras únicas con
                  material que antes considerábamos basura.
                </p>
              </div>
            </div>

            <div className="story-step">
              <div className="step-icon">
                <Heart size={40} />
              </div>
              <div className="step-content">
                <h3>Empoderando Comunidades</h3>
                <p>
                  Decidimos colaborar con mujeres talentosas de áreas rurales que
                  carecían de oportunidades laborales. Juntas, convertimos nuestra
                  visión en hermosas carteras hechas con dedicación, amor y estilo.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="values">
          <h3>Nuestros Valores</h3>
          <div className="values-grid">
            <div className="value-item">
              <h4>Trabajo Artesanal</h4>
              <p>Valoramos y promovemos la apreciación del trabajo hecho a mano</p>
            </div>
            <div className="value-item">
              <h4>Cuidado Ambiental</h4>
              <p>Nos comprometemos a cuidar el medio ambiente a través del reciclaje</p>
            </div>
            <div className="value-item">
              <h4>Empoderamiento</h4>
              <p>Apoyamos a mujeres de áreas rurales sin oportunidades laborales</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;